import { inject, Directive, input, OnInit, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Clipboard } from '@angular/cdk/clipboard';

/**
 * Directive to make text copyable on click.
 */
@Directive({
  selector: '[copyable]',
  standalone: true,
  host: {'(click)': 'onClick()'}
})
export class CopyableDirective implements OnInit {
  private hostElement = inject(ElementRef);
  private readonly clipboard = inject(Clipboard);
  private readonly toastr = inject(ToastrService);

  // The description of the value being copied for toasts and hover text.
  copyLabel = input<string>('');

  // The actual text to copy to the clipboard when the element is clicked.
  copyable = input<string>('');

  ngOnInit(): void {
    // Add class for styling
    this.hostElement.nativeElement.classList.add('copyable');
    // Add in tooltip
    this.hostElement.nativeElement.setAttribute('title', `Copy ${this.copyLabel()}`);
  }

  onClick(): void {
    if (this.clipboard.copy(this.copyable())) {
      this.toastr.success(`Copied ${this.copyLabel()}`);
    } else {
      this.toastr.error(`Failed to copy ${this.copyLabel()}`);
    }
  }
}
